<script>
  import Select from "./Select.svelte";

  export let value = "";
  export let label;
  export let key;
  export let type = "text";
  export let required = false;
  export let options = null;
</script>

<style>
  .form-row {
    margin: 24px 0;
  }

  .form-row label {
    color: #bdbdbd;
    font-size: 13px;
    padding-bottom: 10px;
  }

  .form-row input {
    width: 100%;
    border: 1px solid #bdbdbd;
    padding: 15px;
    margin: 0;
    height: 55px;
    font-size: 16px;
    font-weight: 200;
  }

  .required {
    color: red;
  }
</style>

<div class="form-row">
  <label for={key}>
    {label}
    {#if required}
      <span class="required">*</span>
    {/if}
  </label>
  {#if type === 'select'}
    <Select {key} bind:value {options} />
  {:else if type === 'password'}
    <input on:change name={key} type="password" bind:value />
  {:else}
    <input on:change name={key} type="text" bind:value />
  {/if}
</div>
